import { deck } from './cliente.js';

/** Quem sou, o que posso, e o relogio do servidor. */
export const me = () => deck({ url: '/me' });

/** Sinal de vida. Devolve `server_time` -- e com ele que o timer se ajusta. */
export const ping = () => deck({ method: 'post', url: '/me/ping' });

/** Prioridades e limites de anexo, para a tela nao ter lista propria. */
export const vocabulario = () => deck({ url: '/vocabulary' });

export const membros = (params = {}) => deck({ url: '/members', params });
export const times = () => deck({ url: '/teams' });
export const etiquetas = (params = {}) => deck({ url: '/labels', params });
export const criarEtiqueta = (body) => deck({ method: 'post', url: '/labels', body });

/**
 * Os tipos de issue configurados em algum projeto -- para o filtro de
 * Tarefas, que atravessa projetos. Passe `project` para restringir a um so.
 */
export const tiposDeIssue = (params = {}) => deck({ url: '/issue-types', params });
export const buscar = (q, limit = 10) => deck({ url: '/search', params: { q, limit } });

/* Entrada local de desenvolvimento -- 404 quando DECK_LOGIN_LOCAL e false. */
export const pessoasLocais = () => deck({ url: '/dev/members' });
export const entrarLocal = (login) => deck({ method: 'post', url: '/dev/login', body: { login } });
